import {useState, useEffect} from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Box from "@mui/material/Box";

import Loading from '../../common/Loading';

export default function LoadListFilterReelList(props) {
    //console.debug("RTS Break LoadListFilterReelList");

    const [isLoading, setIsLoading] = useState(true);

    const [reels, setReels] = useState(props.reels===null?[]:props.reels);
    const [repoReels, setRepoReels] = useState(props.data===null?[]:props.data);


    useEffect(() => {
        if(props.reels===null){
            setReels([]);
        }
        else{
            setReels(props.reels);
        }

        if(props.data == null){
            setRepoReels([]);
        }
        else{
            setRepoReels(props.data);
        }

        setIsLoading(false);
    }, [props]);    


    function valChange(e, val){
        props.setReelsFx(val);
        setReels(val);
    } 


    if(isLoading){
        return(
            <Loading />
        );
    }


    return(
        <Autocomplete
            options={repoReels}
            renderInput={(params) => <TextField {...params} label="Reels" size="small" />}
            value={reels}
            onChange={valChange}
            getOptionLabel={(reel) => reel.serialNumber}
            renderOption={(props, repoReels) => (
                <Box component="li" {...props} key={repoReels.idGuid}>
                    {repoReels.serialNumber}
                </Box>
            )}
            multiple
        />
    );
}

